// Pointer-Drag-Helfer für die interaktiven SVG-Vorschauen.
// Übersetzt Pointer-Koordinaten in viewBox-Koordinaten und ruft onMove(cur, start) auf.
// Die Drag-Interaktion ändert nur Eingabewerte, nicht das Rechenprinzip (calc.js bleibt rein).

// startDrag bindet sich an das SVG-Element des Events und liefert während des Ziehens
// fortlaufend die aktuelle und die Startposition in viewBox-Einheiten.
export function startDrag(e, vbW, vbH, onMove) {
  e.preventDefault();
  e.stopPropagation();
  const svg = e.currentTarget.ownerSVGElement || e.currentTarget;
  const toVB = (cx, cy) => {
    const rect = svg.getBoundingClientRect();
    return {
      x: ((cx - rect.left) / rect.width) * vbW,
      y: ((cy - rect.top) / rect.height) * vbH,
    };
  };
  const start = toVB(e.clientX, e.clientY);
  onMove(start, start);
  const move = (ev) => {
    const t = (ev.touches && ev.touches[0]) || ev;
    onMove(toVB(t.clientX, t.clientY), start);
  };
  const up = () => {
    window.removeEventListener("pointermove", move);
    window.removeEventListener("pointerup", up);
  };
  window.addEventListener("pointermove", move);
  window.addEventListener("pointerup", up);
}

export function round1(n) {
  return Math.round(n * 10) / 10;
}

export function clamp(n, a, b) {
  return Math.max(a, Math.min(b, n));
}

export function fmt(n) {
  const r = round1(n);
  return (Number.isInteger(r) ? r.toString() : r.toFixed(1)).replace(".", ",");
}

// Sinnvolle Achsen-Schrittweite je nach sichtbarer Spanne.
export function niceStep(range) {
  if (range <= 24) return 5;
  if (range <= 60) return 10;
  if (range <= 170) return 20;
  if (range <= 420) return 50;
  return 100;
}

export function niceCeil(n) {
  return Math.max(20, Math.ceil(n / 20) * 20);
}
